module.exports = __webpack_public_path__ + "img/arrow-circle-broken-up-right.c778977c.svg";